module.exports = __webpack_public_path__ + "img/adulto43.e072b7e9.jpg";